import React from 'react';
import { Route, Switch } from 'react-router-dom';
import ChangeEmailFormPage from './ChangeEmailFormPage';
import ChangeEmailIntroPage from './ChangeEmailIntroPage';
import ChangeEmailReauthWaitingPage from './ChangeEmailReauthWaitingPage';

const ChangeEmailFeature = () => (
  <Switch>
    <Route path="/maps/settings/change-email/waiting" exact>
      <ChangeEmailReauthWaitingPage />
    </Route>
    <Route path="/maps/settings/change-email/form" exact>
      <ChangeEmailFormPage />
    </Route>
    <Route path="/maps/settings/change-email" exact>
      <ChangeEmailIntroPage />
    </Route>
  </Switch>
);

export default ChangeEmailFeature;
